import React, { useState, useEffect } from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import logoWhite from '../../assets/images/logo-white.png';
import flagBR from '../../assets/images/icons/flag-br.svg';
import flagES from '../../assets/images/icons/flag-es.svg';
import { NavDropdown } from 'react-bootstrap';
import {
  getName,
  getId,
  isAdmin,
  getLocale,
  logout,
} from '../../helpers/helpers_general.js';
import { setLocale } from '../../services/services_general.js';
import NewCategoryModal from '../../components/modals/NewCategoryModal.js';
import NewContentModal from '../../components/modals/NewContentModal.js';
import NewUserModal from '../../components/modals/NewUserModal.js';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import {
  AppBar,
  Box,
  IconButton,
  Link,
  Toolbar,
  Divider,
  SwipeableDrawer,
} from '@mui/material';
import { AlertError, AlertSuccess } from '../../components/Alerts';
import { useAlert } from '../../context';
import { makeStyles } from '@mui/styles';
import './header.scss';

const useStyles = makeStyles(() => ({
  header: {
    backgroundColor: 'primary.main',
    position: 'absolute',
    padding: '0 50px',
    zIndex: '10 !important',
    boxShadow: 'none !important',
  },
}));

const Header = ({ loggedIn }) => {
  const initialState = {
    sidebar: false,
    name: '',
    showNewContentModal: false,
    mobileView: false,
    id: 0,
  };

  const { header } = useStyles();
  const [states, setStates] = useState(initialState);
  const { textSuccessAlert, textErrorAlert } = useAlert();

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 1040
        ? setStates(prevState => ({ ...prevState, mobileView: true }))
        : setStates(prevState => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();
    window.addEventListener('resize', () => setResponsiveness());

    return () => {
      window.removeEventListener('resize', () => setResponsiveness());
    };
  }, []);

  useEffect(() => {
    setStates(prevState => ({ ...prevState, name: getName() }));
    setStates(prevState => ({ ...prevState, id: getId() }));
  }, []);

  const sidebar = open => {
    setStates(prevState => ({ ...prevState, sidebar: open }));
  };

  const Modals = () => (
    <>
      <NewContentModal
        title="Novo Conteúdo"
        showNewContentModal={states.showNewContentModal}
        setStates={setStates}
      />

      <NewCategoryModal
        showCategoryModal={states.showCategoryModal}
        setStates={setStates}
      />

      <NewUserModal showUserModal={states.showUserModal} setStates={setStates} />

      <AlertError textAlert={textErrorAlert} />
      <AlertSuccess textAlert={textSuccessAlert} />
    </>
  );

  const HeaderLinks = ({ sx, sidebarOpen }) =>
    isAdmin() && (
      <Link sx={{ padding: '0 8px', ...sx }} href="/user">
        Usuários
      </Link>
    );

  const displayMobile = () => {
    return (
      <Toolbar
        sx={{ display: 'flex', justifyContent: 'space-between', padding: '0 !important' }}
      >
        <Link href="/home" className="header-logo-link">
          <img
            src={logoWhite}
            alt="Logo da empresa HWater"
            className="header-logo"
          />
        </Link>
        <IconButton
          {...{
            edge: 'start',
            color: 'inherit',
            'aria-label': 'menu',
            'aria-haspopup': 'true',
          }}
          onClick={sidebar}
        >
          <MenuIcon />
        </IconButton>
        <SwipeableDrawer
          anchor="right"
          open={states.sidebar}
          onOpen={() => sidebar(true)}
          onClose={() => sidebar(false)}
        >
          <div
            onClick={() => sidebar(false)}
            onKeyPress={() => sidebar(false)}
            role="button"
            tabIndex={0}
          >
            <IconButton>
              <ChevronRightOutlinedIcon />
            </IconButton>
          </div>
          <Divider />
          <Box
            className={'sidebar-open'}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '300px',
            }}
          >
            <Link
              sx={{
                cursor: 'pointer',
                borderBottom: '1px solid #E2E2E5',
                padding: '10px 20px',
                color: '#49454F',
                fontSize: '14px',
                fontWeight: 500,
                textDecoration: 'none',
                display: 'block',
              }}
              href="/home"
            >
              Home
            </Link>
            <Link
              sx={{
                cursor: 'pointer',
                borderBottom: '1px solid #E2E2E5',
                padding: '10px 20px',
                color: '#49454F',
                fontSize: '14px',
                fontWeight: 500,
                textDecoration: 'none',
                display: 'block',
              }}
              href="/category"
            >
              Conteúdos
            </Link>
            <HeaderLinks
              sidebarOpen="sidebar-open"
              sx={{
                cursor: 'pointer',
                borderBottom: '1px solid #E2E2E5',
                padding: '10px 20px',
                color: '#49454F',
                fontSize: '14px',
                fontWeight: 500,
                textDecoration: 'none',
              }}
            />
            <NavDropdown
              className="nav-dropdown-idiom sidebar-open"
              onSelect={key => {
                setLocale(key);
                window.location.reload();
              }}
              title={getLocale().toUpperCase()}
            >
              <NavDropdown.Item eventKey="pt-BR">
                Pt-BR
              </NavDropdown.Item>
              <NavDropdown.Item eventKey="es">
                ES
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown
              className={'nav-dropdown add sidebar-open'}
              title={`Olá, ${states.name}`}
            >
              <NavDropdown.Item
                href={'#'}
                onClick={() => {
                  logout();
                }}
              >
                {'Sair'}
              </NavDropdown.Item>
            </NavDropdown>
          </Box>
        </SwipeableDrawer>
        <Modals />
      </Toolbar>
    );
  };

  const FlagTitle = ({ locale }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <img src={locale === 'pt-BR' ? flagBR : flagES} alt={locale} style={{ width: '20px', height: '14px', borderRadius: '2px' }} />
      <span style={{ color: '#fff', fontSize: '13px' }}>{locale === 'pt-BR' ? 'PT-BR' : 'ES'}</span>
    </Box>
  );

  const displayDesktop = () => {
    return (
      <Toolbar sx={{ display: 'flex', alignItems: 'center', padding: '0 !important', position: 'relative' }}>

        {/* Esquerda: logo */}
        <Link href="/home" className="header-logo-link" sx={{ flexShrink: 0 }}>
          <img src={logoWhite} alt="Logo da empresa HWater" className="header-logo" />
        </Link>

        {/* Centro absoluto: navegação */}
        <Box sx={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}>
          <Link sx={{ padding: '0 8px', color: '#FFFFFF', fontSize: '13px', fontWeight: 500, textDecoration: 'none', whiteSpace: 'nowrap' }} href="/home">
            Home
          </Link>
          <Link sx={{ padding: '0 8px', color: '#FFFFFF', fontSize: '13px', fontWeight: 500, textDecoration: 'none', whiteSpace: 'nowrap' }} href="/category">
            Conteúdos
          </Link>
          <HeaderLinks sx={{ color: '#FFFFFF', fontSize: '13px', fontWeight: 500 }} />
        </Box>

        {/* Direita: idioma + usuário */}
        <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', gap: '16px' }}>
          <NavDropdown
            className="nav-dropdown-idiom idiom"
            onSelect={key => { setLocale(key); window.location.reload(); }}
            title={<FlagTitle locale={getLocale()} />}
          >
            <NavDropdown.Item eventKey="pt-BR">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={flagBR} alt="Brasil" style={{ width: '20px', height: '14px', borderRadius: '2px' }} />
                Português (Brasil)
              </Box>
            </NavDropdown.Item>
            <NavDropdown.Item eventKey="es">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={flagES} alt="Español" style={{ width: '20px', height: '14px', borderRadius: '2px' }} />
                Español
              </Box>
            </NavDropdown.Item>
          </NavDropdown>
          <NavDropdown className="nav-dropdown add" title={`Olá, ${states.name}`}>
            <NavDropdown.Item href={'/'} onClick={() => logout()}>Sair</NavDropdown.Item>
          </NavDropdown>
        </Box>

        <Modals />
      </Toolbar>
    );
  };

  return (
    <AppBar className={header}>
      {states.mobileView ? displayMobile() : displayDesktop()}
    </AppBar>
  );
};

export default Header;
